export enum GeographyPlatformAccessOperation {
    read = "e3e5bfee-edb7-4bb1-a76c-e8f66bc57580",
}
